/**
 * @generated SignedSource<<f9bb1d7056c8687f9a2e96df5ba89f84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonMatchingEmbeddingFieldType = "CUSTOM_SELECT" | "DEFAULT_ROLE" | "JOB_TITLE" | "NAME" | "SKILL" | "SUMMARY" | "TAG" | "%future added value";
export type PersonMatchingEmbeddingModelType = "ACCOUNT" | "PERSON" | "SKILL" | "%future added value";
export type SmartMatchingContextQuery$variables = {
  filterTargetPeopleIds?: ReadonlyArray<number> | null | undefined;
  limitToPlaceholders?: boolean | null | undefined;
  personId: number;
};
export type SmartMatchingContextQuery$data = {
  readonly smartMatchSimilarPeople: {
    readonly embeddingFields: ReadonlyArray<{
      readonly customSelectTypeId: number | null | undefined;
      readonly field: PersonMatchingEmbeddingFieldType;
      readonly id: number;
      readonly isIncluded: boolean;
      readonly model: PersonMatchingEmbeddingModelType;
    }>;
    readonly people: ReadonlyArray<{
      readonly matchedCustomSelectOptions: ReadonlyArray<{
        readonly distance: number;
        readonly score: number;
        readonly source: {
          readonly id: number;
          readonly typeId: number;
        };
        readonly target: {
          readonly id: number;
          readonly typeId: number;
        } | null | undefined;
      }>;
      readonly matchedSkills: ReadonlyArray<{
        readonly distance: number;
        readonly score: number;
        readonly source: {
          readonly id: number;
          readonly level: number | null | undefined;
        };
        readonly target: {
          readonly id: number;
          readonly level: number | null | undefined;
        } | null | undefined;
      }>;
      readonly personId: number;
      readonly scores: {
        readonly basicProfileMatchScore: number;
        readonly fieldScores: ReadonlyArray<{
          readonly distance: number;
          readonly embeddingFieldId: number;
          readonly score: number;
        }>;
        readonly matchedCustomSelectOptionsScore: number;
        readonly matchedSkillsScore: number;
      };
      readonly totalScore: number;
    }>;
  };
};
export type SmartMatchingContextQuery = {
  response: SmartMatchingContextQuery$data;
  variables: SmartMatchingContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterTargetPeopleIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limitToPlaceholders"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "level",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distance",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "typeId",
    "storageKey": null
  }
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filterTargetPeopleIds",
        "variableName": "filterTargetPeopleIds"
      },
      {
        "kind": "Variable",
        "name": "limitToPlaceholders",
        "variableName": "limitToPlaceholders"
      },
      {
        "kind": "Variable",
        "name": "personId",
        "variableName": "personId"
      }
    ],
    "concreteType": "PersonMatchingResponse",
    "kind": "LinkedField",
    "name": "smartMatchSimilarPeople",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PersonMatching",
        "kind": "LinkedField",
        "name": "people",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalScore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonMatchingSkillScore",
            "kind": "LinkedField",
            "name": "matchedSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonMatchingSkillScoreItem",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonMatchingSkillScoreItem",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonMatchingCustomSelectOptionScore",
            "kind": "LinkedField",
            "name": "matchedCustomSelectOptions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonMatchingCustomSelectOptionScoreItem",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonMatchingCustomSelectOptionScoreItem",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonMatchingScores",
            "kind": "LinkedField",
            "name": "scores",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "basicProfileMatchScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonMatchingFieldScore",
                "kind": "LinkedField",
                "name": "fieldScores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "embeddingFieldId",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchedSkillsScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchedCustomSelectOptionsScore",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PersonMatchingEmbeddingField",
        "kind": "LinkedField",
        "name": "embeddingFields",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "model",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isIncluded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customSelectTypeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SmartMatchingContextQuery",
    "selections": (v8/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SmartMatchingContextQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "e10774a986a40240561485eaaeb9222e",
    "id": null,
    "metadata": {},
    "name": "SmartMatchingContextQuery",
    "operationKind": "query",
    "text": "query SmartMatchingContextQuery(\n  $personId: Int!\n  $filterTargetPeopleIds: [Int!]\n  $limitToPlaceholders: Boolean\n) {\n  smartMatchSimilarPeople(personId: $personId, filterTargetPeopleIds: $filterTargetPeopleIds, limitToPlaceholders: $limitToPlaceholders) {\n    people {\n      personId\n      totalScore\n      matchedSkills {\n        source {\n          id\n          level\n        }\n        target {\n          id\n          level\n        }\n        score\n        distance\n      }\n      matchedCustomSelectOptions {\n        source {\n          id\n          typeId\n        }\n        target {\n          id\n          typeId\n        }\n        score\n        distance\n      }\n      scores {\n        basicProfileMatchScore\n        fieldScores {\n          embeddingFieldId\n          score\n          distance\n        }\n        matchedSkillsScore\n        matchedCustomSelectOptionsScore\n      }\n    }\n    embeddingFields {\n      id\n      field\n      model\n      isIncluded\n      customSelectTypeId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b728a6d912322a922144cf4551ff5b55";

export default node;
